import React, { useState } from "react";

import styles from "./PaigeReview.module.scss";

var FindingCard = function (props) {
  var finding = props.finding;
  var analysisType = props.analysisType;
  var onFindingClick = props.onFindingClick;

  var _expanded = useState(false);
  var isExpanded = _expanded[0];
  var setIsExpanded = _expanded[1];

  var getSeverityClass = function () {
    switch (finding.severity) {
      case "critical":
        return styles.severityCritical;
      case "warning":
        return styles.severityWarning;
      case "info":
        return styles.severityInfo;
      default:
        return "";
    }
  };

  var handleHeaderClick = function () {
    setIsExpanded(!isExpanded);
  };

  var handleNavigateClick = function (e) {
    e.stopPropagation();
    if (onFindingClick && finding.page_number != null) {
      onFindingClick(finding);
    }
  };

  // Keys must be quoted strings. An unquoted numeric literal like 2.10 is
  // parsed as the number 2.1, so its key would become "2.1" and never match
  // the backend's code_section string "2.10".
  var codeSectionLinkMap = {
    2.6: "/references/7/pid/e9a09e3b-3289-bfc9-8058-b28e15c9d31d",
    2.4: "/references/7/pid/79d68376-cf1d-b18f-1418-f69aa879204a",
    "2.10": "/references/7/pid/6e052907-fb88-2274-47fc-eccba92fed94",
    4.2: "/references/7/pid/8b2c2b8b-5057-3121-b83d-4fca709c093a",
    4.3: "/references/7/pid/0ac149f0-b59c-9b7e-824a-c25003b47539",
  };

  var renderCodeSection = function () {
    // For Illumina, show the rule_id directly (e.g., "ruo-footer-per-page")
    if (analysisType === "illumina") {
      if (!finding.rule_id) return null;
      return <span className={styles.codeSection}>{finding.rule_id}</span>;
    }

    // For Menopur, show "Rule <rule_id>" (e.g., "Rule 1.1")
    if (analysisType === "menopur") {
      if (!finding.rule_id) return null;
      return <span className={styles.codeSection}>Rule {finding.rule_id}</span>;
    }

    if (!finding.code_section) return null;

    // For PAAB, prefix with "PAAB Code"
    // For FDA, the code_section already contains the CFR citation (e.g., "21 CFR 202.1(e)(6)(i)")
    var label =
      analysisType === "fda"
        ? finding.code_section
        : "Regulatory Code " + finding.code_section;

    var link = codeSectionLinkMap[finding.code_section];

    if (link) {
      return (
        <a
          href={link}
          className={styles.codeSection + " " + styles.codeSectionLink}
          onClick={function (e) {
            e.stopPropagation();
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      );
    }

    return <span className={styles.codeSection}>{label}</span>;
  };

  // Menopur findings don't carry violation_direction (missing/spurious doesn't
  // apply to visual imagery). Show the severity word instead so the badge text
  // reads naturally (e.g., "Critical", "Warning").
  var renderBadgeLabel = function () {
    if (analysisType === "menopur") {
      if (finding.severity === "critical") return "Critical";
      if (finding.severity === "warning") return "Warning";
      if (finding.severity === "info") return "Info";
      return "Issue";
    }
    if (
      finding.metadata &&
      finding.metadata.violation_direction === "spurious"
    ) {
      return "Spurious";
    }
    if (finding.severity === "warning") return "Warning";
    if (finding.severity === "info") return "Info";
    return "Critical";
  };

  var cardClass = isExpanded
    ? styles.findingCard + " " + styles.findingCardExpanded
    : styles.findingCard;

  return (
    <div className={cardClass}>
      <div className={styles.findingHeader} onClick={handleHeaderClick}>
        <span className={styles.severityBadge + " " + getSeverityClass()}>
          {renderBadgeLabel()}
        </span>
        <span className={styles.findingCategory}>{finding.category}</span>
        {renderCodeSection()}
        {finding.page_number != null && (
          <span className={styles.headerPageNote}>p.{finding.page_number}</span>
        )}
        <span className={styles.expandToggle}>
          {isExpanded ? "\u25B2" : "\u25BC"}
        </span>
      </div>

      {isExpanded && (
        <div className={styles.findingBody}>
          <div className={styles.findingDescription}>{finding.description}</div>

          {finding.extracted_text && (
            <div className={styles.extractedText}>
              <span className={styles.quoteIcon}>"</span>
              {finding.extracted_text}
              <span className={styles.quoteIcon}>"</span>
            </div>
          )}

          {finding.recommendation && (
            <div className={styles.recommendation}>
              <div className={styles.recommendationLabel}>Recommendation</div>
              <div className={styles.recommendationText}>
                {finding.recommendation}
              </div>
            </div>
          )}

          {finding.page_number != null && (
            <div className={styles.findingFooter}>
              <span
                className={styles.pageNoteLink}
                onClick={handleNavigateClick}
              >
                Go to page {finding.page_number}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FindingCard;
